// src/layouts/PublicLayout.js
import React from "react";
import { Outlet } from "react-router-dom";

function PublicLayout({ children }) {
  return (
    <div className="public-layout">
      <nav>Navbar</nav>
      <main><Outlet /></main>
      <footer>Footer</footer>
    </div>
  );
}

export default PublicLayout;
